export const LOGIN_FULFILLED = 'LOGIN_FULFILLED';
export const LOGIN_REJECTED = 'LOGIN_REJECTED';
export const REGISTERATION_FULLFILED = 'REGISTERATION_FULLFILED';
export const REGISTERATION_PROCESS = 'REGISTERATION_PROCESS';
export const REGISTERATION_REJECTED = 'REGISTERATION_REJECTED';
